export default "__VITE_ASSET__08cbbebb__"